<template>
  <!-- This component renders nothing -->
  <div style="display: none;"></div>
</template>

<script>
export default {
  name: 'CommonLocalBusinessSchemaComponent',
  mounted() {
    const oldScript = document.getElementById('common-local-business-schema');
    if (oldScript) oldScript.remove();

    const path = window.location.pathname;
    const blogDetailUrl = path.split('/').includes('blog');

    if (['/', '/blog'].includes(path) || blogDetailUrl) {
      const localbusinesSchema = document.createElement('script');
      localbusinesSchema.setAttribute('type', 'application/ld+json');
      localbusinesSchema.setAttribute('id', 'common-local-business-schema');
      localbusinesSchema.text = `
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "EL Connect",
        "url": "https://elconnect.sg/",
        "logo": "https://elconnect.sg/logo.png",
        "image": "https://elconnect.sg/logo.png",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "745 Lor. 5 Toa Payoh, #03-02",
          "addressLocality": "Singapore",
          "addressRegion": "Singapore",
          "addressCountry": "SG",
          "postalCode": "319455",
          "Telephone": "+65 68029119"
        },
        "sameAs": [
          "https://www.facebook.com/elconnectsgp",
          "https://www.instagram.com/elconnectsgp",
          "https://www.youtube.com/c/elconnect"
        ]
      }`;
      document.head.appendChild(localbusinesSchema);
    }
  }
};
</script>
